module.exports = __webpack_public_path__ + "static/HospitalTengkuAmpuanAfzan-color-68302e9aff9d29f33c2d3f5396b85a75.png";